import { styled } from '@mui/material/styles';
import { Link } from 'core/common/ui/ui-kit';

export const ContainerStyled = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LinkStyled = styled(Link)`
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
  }
`;
